import axios from "axios";
import Cookies from "js-cookie";

/**
 * Trigger next.js revalidation endpoint for a given path.
 *
 * @param {string} path  A string like "/some/page" that should be revalidated.
 *                        It is up to the caller to supply the correct path.
 *                        If no path is supplied we fall back to the current
 *                        window location (client only).
 */
const revalidate = async (path) => {
  try {
    await axios.post(
      "https://kumail.shop/api/revalidate",
      { path: path },
      {
        headers: {
          "Content-Type": "application/json",
          "x-revalidate-secret": "REVALIDATE_SECRET",
          "X-CSRFToken": Cookies.get("csrftoken"),
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept, Authorization",
        },
      }
    );
  } catch (err) {
    // don't break the admin UI if revalidation fails
    // eslint-disable-next-line no-console
    console.error("revalidation failed for", path, err);
  }
};

export default revalidate;
